import React from "react";
import {
  Flex,
} from "@chakra-ui/react";
import PostDetails from "./components/PostDetails"
const Data = () => {
  return (
    <Flex direction="column" pt={{ base: "62px", md: "75px", xl: "88px" }}>
      <PostDetails />
    </Flex>
  );
}

export default Data;
